import React from 'react';
import PropTypes from 'prop-types';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import Spacing from '@marvelapp/marvel-ui/spacing';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';

import Image from 'marketing-website/components/modules/Image';
import ParallaxWrapper from 'marketing-website/components/wrappers/ParallaxWrapper';
import Pattern from 'marketing-website/components/commons/Pattern';
import Shape from 'marketing-website/components/commons/Shape';

import generalStyles from './style/general.module.css';

export default function MediaThreeColImages({
  background,
  fallbackImage,
  images,
  radius,
}) {
  const maxWidth = 380;
  const offsets = [100, -50, -200];
  const totalColumns = 12;
  const columnWidth = totalColumns / images.length;
  const imageStyles = { maxWidth: fallbackImage.maxWidth };

  return (
    <div className={generalStyles.threeColImages}>
      {background === 'color' && <div className={generalStyles.bg} />}

      {background === 'shape' && (
        <div>
          <ParallaxWrapper speed={1}>
            <Shape
              type="square"
              color="purple"
              width={340}
              height={250}
              top="70%"
              left="44%"
            />
          </ParallaxWrapper>
          <Pattern color="purple" top="80%" left="40%" type="fish" />
        </div>
      )}

      <PageWrap size="l">
        <Spacing type="padding" size="xl" position="topBottom">
          <div className={generalStyles.grid}>
            <Grid columns={totalColumns} size="l">
              {images.map((item, index) => (
                <GridItem columnSpan={columnWidth} key={item.id}>
                  <div style={{ transform: `translateY(${offsets[index]}px)` }}>
                    <Image
                      alt={item.alt}
                      maxWidth={maxWidth}
                      src={item.src}
                      borderRadius={radius}
                    />
                  </div>
                </GridItem>
              ))}
            </Grid>
          </div>
          <div className={generalStyles.image} style={imageStyles}>
            <Image {...fallbackImage} hasShadow={false} />
          </div>
        </Spacing>
      </PageWrap>
    </div>
  );
}

MediaThreeColImages.propTypes = {
  background: PropTypes.oneOf(['shape', 'color', 'none']),
  fallbackImage: PropTypes.object.isRequired,
  images: PropTypes.array.isRequired,
  radius: PropTypes.string,
};

MediaThreeColImages.defaultProps = {
  background: 'color',
  radius: 'l',
};



// WEBPACK FOOTER //
// ./src/components/modules/Media/MediaThreeColImages/index.js